import { render, staticRenderFns } from "./PriceDiscTablePurch.vue?vue&type=template&id=59dc2822"
import script from "./PriceDiscTablePurch.vue?vue&type=script&lang=js"
export * from "./PriceDiscTablePurch.vue?vue&type=script&lang=js"
import style0 from "./PriceDiscTablePurch.vue?vue&type=style&index=0&id=59dc2822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports